module.exports = "/wp-content/themes/conversion/public/dist//svgs/our_approach_tile_icon.svg";